import apiClient from '@/services/api'

export default {
  async sendAssociateToOnboarding(_, { associate, type }) {
    try {
      const { data } = await apiClient.patch('/api/complete_request/project/recipients_add', { associate, type })

      if (data.error_code && data.error_code !== '0') {
        throw new Error(`${data.msg}`)
      }
    } catch (error) {
      throw error.message
    }
  },

  async getCompleteRequests({ commit, rootState }, { page = 1, size = 10, filter }) {
    try {
      const { data } = await apiClient.post(
        '/api/complete_request/project/get_all',
        {
          project_id: rootState.applicationState.currentProject.id,
          page,
          size,
          filter: {
            ...filter,
            types: filter.types ?? []
          }
        },
        {
          cancelPreviousRequests: true
        }
      )

      if (data.error_code && data.error_code !== '0') {
        throw new Error(`${data.msg}`)
      }

      commit('SET_COMPLETE_REQUESTS', data)
    } catch (error) {
      throw error.message
    }
  },

  async getCompleteRequest({ commit }, { request_id }) {
    try {
      const { data } = await apiClient.post('/api/complete_request/project/get', {
        request_id
      })

      if (data.error_code && data.error_code !== '0') {
        throw new Error(`${data.msg ?? 'An error occurred while loading the document request.'}`)
      }

      commit('SET_COMPLETE_REQUEST', data)
    } catch (error) {
      throw error.message
    }
  },

  async getSignedAssociates(_, { request_id, page = 1, size = 10, filter }) {
    try {
      const { data } = await apiClient.post('/api/complete_request/project/signed_associates/get', {
        request_id,
        page,
        size,
        filter
      })

      if (data.error_code && data.error_code !== '0') {
        throw new Error(`${data.msg ?? 'An error occurred while loading the signed associates.'}`)
      }

      return data
    } catch (error) {
      throw error.message
    }
  },

  async getAssociatesToSign(_, { request_id, page = 1, size = 10, filter }) {
    try {
      const { data } = await apiClient.post('/api/complete_request/project/associates_to_sign/get', {
        request_id,
        page,
        size,
        filter
      })

      if (data.error_code && data.error_code !== '0') {
        throw new Error(`${data.msg ?? 'An error occurred while loading the associates to sign.'}`)
      }

      return data
    } catch (error) {
      throw error.message
    }
  },

  async getStatistic(_, { request_id }) {
    try {
      const { data } = await apiClient.get(`/api/complete_request/project/${request_id}/sequence_statistic`)

      if (data.error_code && data.error_code !== '0') {
        throw new Error(`${data.msg ?? 'An error occurred while loading the statistic.'}`)
      }

      return data.items
    } catch (error) {
      throw error.message
    }
  },

  async postReviewAllCompleteRequest(_, { request_id, signature_id }) {
    try {
      const { data } = await apiClient.post('/api/complete_request/project/review_all', {
        request_id,
        signature_id
      })

      if (data.error_code && data.error_code !== '0') {
        throw new Error(`${data.msg ?? 'An error occurred while review all.'}`)
      }
    } catch (error) {
      throw error.message
    }
  },

  async postCreateCompleteRequest({ rootState }, { complete_request }) {
    try {
      const { data } = await apiClient.post('/api/complete_request/project/create', {
        project_id: rootState.applicationState.currentProject.id,
        author_id: complete_request.author_id ?? rootState.applicationState.associate.id,
        ...complete_request
      })

      if (data.error_code && data.error_code !== '0') {
        throw new Error(`${data.msg ?? 'An error occurred while create document request.'}`)
      }
    } catch (error) {
      throw error.message
    }
  },

  async postExtendCompleteRequest({ rootState }, { request_id, scope, comment, author_id }) {
    try {
      const { data } = await apiClient.post('/api/complete_request/project/extend', {
        project_id: rootState.applicationState.currentProject.id,
        author_id: author_id ?? rootState.applicationState.associate.id,
        request_id,
        scope,
        comment
      })

      if (data.error_code && data.error_code !== '0') {
        throw new Error(`${data.msg ?? 'An error occurred while extending document request.'}`)
      }
    } catch (error) {
      throw error.message
    }
  },

  async postCreateMultiplyCompleteRequest({ rootState }, { complete_request }) {
    try {
      const { data } = await apiClient.post('/api/complete_request/project/create_multiple', {
        project_id: rootState.applicationState.currentProject.id,
        author_id: complete_request.author_id ?? rootState.applicationState.associate.id,
        ...complete_request
      })

      if (data.error_code && data.error_code !== '0') {
        throw new Error(`${data.msg}`)
      }
    } catch (error) {
      throw error.message
    }
  },

  async postCheckCompleteRequest({ rootState }, { object_id, filter }) {
    try {
      const { data } = await apiClient.post('/api/complete_request/project/check', {
        object_id,
        filter: {
          ...filter,
          project_id: rootState.applicationState.currentProject.id
        }
      })

      if (data.error_code && data.error_code !== '0') {
        throw new Error(`${data.msg ?? 'An error occurred while extending document request.'}`)
      }

      return data.request
    } catch (error) {
      throw error.message
    }
  },

  async deleteAssociateFromCompleteRequest(_, { request_id, associate }) {
    try {
      const { data } = await apiClient.post('/api/complete_request/project/remove', {
        request_id,
        associate
      })

      if (data.error_code && data.error_code !== '0') {
        throw new Error(`${data.msg ?? 'An error occurred while removing associate.'}`)
      }
    } catch (error) {
      throw error.message
    }
  },

  async postCancelCompleteRequest(_, { request_id }) {
    try {
      const { data } = await apiClient.post('/api/complete_request/project/cancel', {
        request_id
      })

      if (data.error_code && data.error_code !== '0') {
        throw new Error(`${data.msg}`)
      }
    } catch (error) {
      throw error.message
    }
  },

  async postRetakeCompleteRequest(_, { request_id }) {
    try {
      const { data } = await apiClient.post('/api/complete_request/project/reassign', {
        request_id
      })

      if (data.error_code && data.error_code !== '0') {
        throw new Error(`${data.msg}`)
      }
    } catch (error) {
      throw error.message
    }
  },

  async postCompleteCompleteRequest(_, { request_id }) {
    try {
      const { data } = await apiClient.post('/api/complete_request/project/force_complete', {
        request_id
      })

      if (data.error_code && data.error_code !== '0') {
        throw new Error(`${data.msg}`)
      }

      return data.request
    } catch (error) {
      throw error.message
    }
  },

  async updateCompleteRequest(_, { form }) {
    try {
      const { data } = await apiClient.post('/api/complete_request/project/edit', {
        ...form
      })

      if (data.error_code && data.error_code !== '0') {
        throw new Error(`${data.msg}`)
      }

      return data.request
    } catch (error) {
      throw error.message
    }
  },

  async patchCompleteRequestSeverity(_, { request_id, severity }) {
    try {
      const { data } = await apiClient.patch(`/api/complete_request/${request_id}/change_severity`, {
        severity
      })

      if (data.error_code && data.error_code !== '0') {
        throw new Error(`${data.msg ?? 'An error occurred while change urgency.'}`)
      }
    } catch (error) {
      throw error.message
    }
  },

  async patchCompleteRequestBackfill({ rootState }, { request_id, date, associate }) {
    try {
      const { data } = await apiClient.patch('/api/complete_request/project/backfill', {
        request_id,
        date,
        associate,
        author_id: rootState.applicationState.associate.id
      })

      if (data.error_code && data.error_code !== '0') {
        throw new Error(`${data.msg ?? 'An error occurred while change urgency.'}`)
      }
    } catch (error) {
      throw error.message
    }
  },

  async postCompleteRequestArchive(_, { request_id }) {
    try {
      const { data } = await apiClient.post('/api/complete_request/project/archive', {
        request_id
      })

      if (data.error_code && data.error_code !== '0') {
        throw new Error(`${data.msg ?? 'An error occurred while archiving.'}`)
      }
    } catch (error) {
      throw error.message
    }
  }
}
